export default function Home() {
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        margin: 0,
        padding: 0,
        background: "#020617",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <svg
        viewBox="0 0 1600 900"
        preserveAspectRatio="xMidYMid slice"
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",      // ← MAGIA PARA ELIMINAR ESPACIOS
        }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="bgGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#020617" />
            <stop offset="50%" stopColor="#02091a" />
            <stop offset="100%" stopColor="#020617" />
          </linearGradient>

          <linearGradient id="ipBoxGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#3B82F6" />
            <stop offset="100%" stopColor="#1D4ED8" />
          </linearGradient>

          <filter id="softGlow" x="-40%" y="-40%" width="180%" height="180%">
            <feGaussianBlur stdDeviation="40" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>

          <filter id="textGlow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="3" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        <rect width="1600" height="900" fill="url(#bgGradient)" />

        <g fill="#60A5FA" opacity="0.3">
          <circle cx="250" cy="180" r="3" />
          <circle cx="550" cy="120" r="2.5" />
          <circle cx="900" cy="160" r="2" />
          <circle cx="1250" cy="130" r="3" />
          <circle cx="300" cy="350" r="2" />
          <circle cx="1400" cy="380" r="2.5" />
          <circle cx="450" cy="650" r="2.5" />
          <circle cx="1050" cy="620" r="3" />
          <circle cx="1350" cy="720" r="2" />
          <circle cx="220" cy="720" r="2" />
        </g>

        <g filter="url(#softGlow)">
          <rect
            x="300"
            y="200"
            rx="32"
            ry="32"
            width="1000"
            height="420"
            fill="rgba(15,23,42,0.92)"
            stroke="#1D4ED8"
            strokeWidth="1"
          />

          <rect
            x="300"
            y="200"
            width="1000"
            height="80"
            rx="32"
            ry="32"
            fill="rgba(148,163,184,0.06)"
          />

          <rect
            x="360"
            y="250"
            width="220"
            height="220"
            rx="20"
            fill="url(#ipBoxGradient)"
          />

          <text
            x="470"
            y="395"
            textAnchor="middle"
            fontFamily="Arial, Helvetica, sans-serif"
            fontSize="120"
            fontWeight="700"
            fill="#FFFFFF"
          >
            IP
          </text>

          <text
            x="830"
            y="360"
            fontFamily="Arial, Helvetica, sans-serif"
            fontSize="120"
            fontWeight="700"
            fill="#FFFFFF"
            filter="url(#textGlow)"
          >
            DEPOT
          </text>

          <rect
            x="380"
            y="420"
            width="840"
            height="1.5"
            fill="rgba(148,163,184,0.35)"
          />

          <text
            x="450"
            y="470"
            fontFamily="Arial, Helvetica, sans-serif"
            fontSize="30"
            fontWeight="500"
            letterSpacing="0.32em"
            fill="#E5E7EB"
          >
            SISTEMA DE INVENTARIO V2
          </text>

          <text
            x="450"
            y="525"
            fontFamily="Arial, Helvetica, sans-serif"
            fontSize="24"
            fontWeight="400"
            fill="#9CA3AF"
          >
            Tecnología · Seguridad · Innovación
          </text>
        </g>
      </svg>
    </div>
  );
}
